module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h2uaC"))).then(() => parcelRequire('1iHdE'));